// Imports
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment';
import 'moment/locale/da'
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {SingleDatePicker} from 'react-dates';

class InputDatePicker extends Component {
  constructor(props) {
    super(props)
    moment.locale('da'); // Danish

    this.state = {
      focused: false,
      date: null,
    }
  }

  renderMonthElement = ({ month, onMonthSelect, onYearSelect }) =>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div>
        <select
          value={month.month()}
          onChange={(e) => onMonthSelect(month, e.target.value)}
        >
          {moment.months().map((label, value) => (
            <option value={value} key={value}>{label}</option>
          ))}
        </select>
      </div>
    </div>

  render() {
      const { type, fullWidth, placeholder, value, minWidth, ...other } = this.props
      return (
        <div className="group">
          <SingleDatePicker
            showDefaultInputIcon
            displayFormat="D MMM"
            small={true}
            block={false}
            numberOfMonths={1}
            date={this.state.date}
            onDateChange={this.props.onDateChange}
            focused={this.state.focused}
            onFocusChange={({ focused }) =>
              this.setState({ focused })
            }
            isOutsideRange={() => false}
            openDirection="up"
            hideKeyboardShortcutsPanel={true}
            renderMonthElement={this.renderMonthElement}
            />
        </div>
      )
  }

}

// Component Properties
InputDatePicker.propTypes = {
  type: PropTypes.string,
  fullWidth: PropTypes.bool
}
InputDatePicker.defaultProps = {
  type: 'button',
  fullWidth: false
}

export default InputDatePicker


// WEBPACK FOOTER //
// ./src/ui/input/InputDatePicker.js